import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class StatusService {
  constructor() {}

  timeLeft = 0;
  showTimeLeft = false;
  showModalWhen = 30;
  tokenTimeExpired = 3600;
  retryLogin = 3;
  isLoading = false;
  showError = false;
  messageError: StatusErrorMessageEnum;
  messageSuccess: StatusSuccessMessageEnum;
  messageInformation = StatusInformationMessageEnum;

  private toastSubject = new Subject<any>(); // 'Subject' é usado para emitir eventos para os observadores.
  toastState = this.toastSubject.asObservable(); // 'toastState' é um Observable que os componentes podem se inscrever para receber notificações de toasts.

  //showType pode ser information, error ou success
  showToast(showType: string, message: string) {
    // Emite um novo evento para notificar os observadores sobre o novo toast.
    this.toastSubject.next({ showType, message });
  }
}

export enum StatusErrorMessageEnum {
  INVALID_CREDENTIALS = 'Proposta ou CPF/CNPJ inválido(s)',
  INTERNAL_SERVER_ERROR = 'Sentimos pelo incoveniente. Por favor, tente novamente mais tarde.',
}

export enum StatusSuccessMessageEnum {
  EXCLUSION_REPRESENTANT = 'representante excluído',
  EXCLUSION_PARTICIPANT = 'procurador excluído',
  EXCLUSION_ACCOUNT = 'conta excluída',
}

export enum StatusInformationMessageEnum {
  SESSION_EXPIRED = 'Sua sessão expirou. Por favor, faça login novamente.',
}
